import { useState } from 'react';
import {
  Input,
  FormLabel,
  FormControl,
  InputRightElement,
  InputGroup,
  Image
} from '@chakra-ui/react';

const CustomInput = ({
  label,
  onChange,
  placeholder,
  isPassword,
  type,
  labelColor,
  labelSize
}) => {
  const [value, setValue] = useState('');
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const handleChange = (e) => {
    setValue(e.target.value);
    onChange(e.target.value);
  }

  const inputType = type ? type : !isPassword ? 'text' : isPasswordShown ? 'text' : 'password';
  return (
    <FormControl>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : 12}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          value={value}
          onChange={(e) => handleChange(e)}
          type={inputType}
          placeholder={placeholder}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={12}
          lineHeight={"20"}
          color={"#898989"}
        />
        {isPassword && (
          <InputRightElement onClick={() => setIsPasswordShown((p) => !p)}>
            {isPasswordShown ? (
              <Image
                src={require("../../assets/svgs/eye-crossed.svg").default}
              />
            ) : (
              <Image src={require("../../assets/svgs/eye.svg").default} />
            )}
          </InputRightElement>
        )}
      </InputGroup>
    </FormControl>
  );
}

export default CustomInput